@import '../../themes/capsule.globals';

:host {
  --tab-top-padding: 5px;
  --tab-bottom-padding: 5px;
  --tab-left-padding: 16px;
  --tab-right-padding: 16px;

  --tabs-border-radius: var(--cpsl-border-radius-tabs);
  --tabs-font-size: 12px;
  --tabs-line-height: 24px;
  --tabs-border-width: 1px;
  --tabs-border-color: var(--cpsl-color-tabs-border);
  --tabs-background-color: var(--cpsl-color-tabs-background);

  --slider-background-color: var(--cpsl-color-tabs-slider-background);

  display: inline-block;
  width: fit-content;
  max-width: 100%;
  font-family: $font-family-base;
}

:host(.full-width) {
  display: block;
}

.tabs-container {
  position: relative;
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;

  border-width: var(--tabs-border-width);
  border-style: solid;
  border-color: var(--tabs-border-color);
  border-radius: var(--tabs-border-radius);

  background: var(--tabs-background-color);

  font-size: var(--tabs-font-size);
  line-height: var(--tabs-line-height);

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.slider {
  position: absolute;
  top: calc(var(--tabs-border-width) * -1);
  bottom: calc(var(--tabs-border-width) * -1);
  left: -1px;
  margin: 4px;

  border-radius: var(--tabs-border-radius);

  background: var(--slider-background-color);
}

.loaded {
  transition: all 0.5s;
}
